// Auto-updated by `npm run render:terminal-demo`. Bumped each render to cache-bust the MP4.
export const TERMINAL_DEMO_VERSION = '1777515896204';
